import React from 'react'

const features = [
  {
    icon: 'expertise',
    title: 'Practical expertise',
    description: 'Clear recommendations and technology choices that fit your goals, budget, and team.',
  },
  {
    icon: 'speed',
    title: 'Fast response',
    description: 'Thoughtful communication and dependable delivery without unnecessary complexity.',
  },
  {
    icon: 'secure',
    title: 'Secure by design',
    description: 'Reliable foundations, responsible practices, and solutions built to protect your work.',
  },
  {
    icon: 'growth',
    title: 'Ready to grow',
    description: 'Flexible digital systems that can evolve as your business and ambitions move forward.',
  },
]

function FeatureIcon({ type }) {
  const iconProps = {
    className: 'h-6 w-6',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '1.8',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  }

  if (type === 'expertise') {
    return <svg {...iconProps}><path d="M12 3 4.5 6v5.5c0 4.5 3 7.8 7.5 9.5 4.5-1.7 7.5-5 7.5-9.5V6L12 3Z" /><path d="m8.5 12 2.3 2.3 4.8-4.8" /></svg>
  }

  if (type === 'speed') {
    return <svg {...iconProps}><path d="M13 2 5 13h6l-1 9 8-11h-6l1-9Z" /></svg>
  }

  if (type === 'secure') {
    return <svg {...iconProps}><rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" /></svg>
  }

  return <svg {...iconProps}><path d="M4 17 10 11l4 4 6-7" /><path d="M15 8h5v5" /><path d="M4 21h16" /></svg>
}

function Feature() {
  return (
    <section className="relative overflow-hidden bg-[#071a3d] py-14 text-white sm:py-16">
      <div className="absolute inset-0 bg-gradient-to-br from-[#071a3d] via-[#0b2d63] to-[#123f7a]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex rounded-full border border-cyan-300/30 bg-cyan-300/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.2em] text-cyan-300">Why Papreja</span>
            <h2 className="mt-3 text-3xl font-black tracking-tight sm:text-4xl">Built around your momentum.</h2>
          </div>
          <p className="max-w-sm text-sm leading-6 text-blue-100">Technology should make the next step clearer, not harder.</p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature) => (
            <article key={feature.title} className="group relative overflow-hidden rounded-2xl border border-white/15 bg-gradient-to-br from-white/12 to-white/[0.03] p-5 shadow-lg shadow-slate-950/10 backdrop-blur-sm transition duration-300 hover:-translate-y-1 hover:border-cyan-300/70 hover:shadow-cyan-950/30">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-cyan-400 text-[#071a3d] shadow-lg shadow-cyan-400/20 ring-4 ring-cyan-300/10 transition-transform duration-300 group-hover:rotate-6">
                <FeatureIcon type={feature.icon} />
              </span>
              <h3 className="mt-6 text-lg font-bold">{feature.title}</h3>
              <p className="mt-2 text-sm leading-6 text-blue-100">{feature.description}</p>
              <span className="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 bg-cyan-300 transition-transform duration-300 group-hover:scale-x-100" />
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Feature

